import { useAuthStore } from '../stores/auth.store';
import Config from '../utils/config';

class HubspotService {
    constructor() {}

    async init() {
        const authStore = useAuthStore();
        const user = authStore.user;
        const company = authStore.authState?.tenantsState?.activeTenant;

        const identifyCustomer = (user) => {
            if (window._hsq) {
                console.log('Hubspot script loaded');
                window._hsq.push([
                    'identify',
                    {
                        email: user.email,
                        name: user.name,
                        company: company.name
                    }
                ]);

                window._hsq.push(['setPath', window.location.pathname]);
                window._hsq.push(['trackPageView']);
            } else {
                console.log('Hubspot script not loaded');
            }
        };

        return identifyCustomer(user);
    }
}

export default new HubspotService();
